import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'sourceEventValidity',
  'sourceCauseCode',
  'tsunamiEventId',
  'sourceEqMagnitude',
  'volcanoEventId',
  'moreInfo',
  'doubtful',
  'country',
  'area',
  'locationName',
  'latitude',
  'longitude',
  'distFromSource',
  'arrDay',
  'arrHour',
  'arrMin',
  'maxWaveArrDay',
  'maxWaveArrHour',
  'maxWaveArrMin',
  'travHours',
  'travMins',
  'runupHt',
  'runupHoriz',
  'typeMeasurementId',
  'period',
  'firstMotion',
  'deaths',
  'deathsAmountOrder',
  'missing',
  'missingAmountOrder',
  'injuries',
  'injuriesAmountOrder',
  'damageMillionsDollars',
  'damageAmountOrder',
  'housesDestroyed',
  'housesDestroyedAmountOrder',
  'housesDamaged',
  'housesDamagedAmountOrder',
]);

export const sort = fromJS([
  { id: 'year', asc: true },
  { id: 'month', asc: true },
  { id: 'day', asc: true },
  { id: 'hour', asc: true },
  { id: 'minute', asc: true },
  { id: 'second', asc: true },
]);

export const minColumns = fromJS([
  'year',
  'month',
  'day',
  'tsunamiEventId',
  'moreInfo',
  'locationName',
  'runupHt',
]);
